<template>
  <v-dialog v-model="dialog" width="fit-content" @click:outside="onCancel()">
    <v-card class="pa-sm-4">
      <v-card-title class="justify-center">
        <v-icon color="error" x-large>
          mdi-help-circle-outline
        </v-icon>
      </v-card-title>

      <v-card-text>
        <v-card-title class="justify-center text-size pa-0">
          We have updated the website. Reload is required to apply new changes.
        </v-card-title>
      </v-card-text>

      <v-card-actions>
        <div class="mx-auto">
          <v-btn class="mx-1" width="100" color="primary" @click="onClick()">
            Reload
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    this.$bus.$on("appversion", options => {
      this.dialog = true;
    });
  },
  methods: {
    onClick() {
      this.dialog = false;
      window.location.reload(1);
    }
  }
};
</script>

<style>
.text-size {
  font-size: 16px;
}
</style>
